// Calculate distance between two coordinates in km using Haversine formula
export function calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1); 
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  const d = R * c; // Distance in km
  return d;
}

function deg2rad(deg: number): number {
  return deg * (Math.PI/180);
}

// Fetch coordinates from ViaCEP using Nominatim (OpenStreetMap) as fallback or Google Maps if needed
// ViaCEP doesn't return lat/lon, so we need a geocoding service.
// Let's use a free open street map API for geocoding based on address
export async function geocodeAddress(address: string): Promise<{lat: number, lon: number} | null> {
  const tryQuery = async (q: string) => {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(q)}`,
      { headers: { 'Accept-Language': 'pt-BR' } }
    );
    const data = await response.json();
    if (data && data.length > 0) {
      return { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) };
    }
    return null;
  };

  try {
    // Tentativa 1: endereço completo com estado e país
    const result = await tryQuery(`${address}, MG, Brasil`);
    if (result) return result;

    // Tentativa 2: apenas cidade + MG (fallback para endereços incompletos)
    const cityMatch = address.split(',').slice(-1)[0]?.trim();
    if (cityMatch) {
      const fallback = await tryQuery(`${cityMatch}, MG, Brasil`);
      if (fallback) return fallback;
    }

    return null;
  } catch (_error) {
    return null;
  }
}
